import React, { Component } from 'react';
import instance from "./axios-instance";
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lottolist: [],
            activeLottoIndex: 0,
            activeLotto: null,
            loadingLotto: false,

            playerid: null,
            user_id: null,
            username: null,
            point: null,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null
        };
    }

    async componentDidMount() {
        this.checklogin();
        await this.getLotteryList();
    }

    checklogin = () => {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);

            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                username: decoded.message.username || decoded.message.Username || decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true
            });
        } else {
            this.setState({
                loginstate: false
            });
        }
    };

    notify = async (type, text) => {
        if (typeof this.props?.notify === "function") {
            this.props.notify(type, text);
            return;
        }

        alert(text);
    };

    setCache = (cacheKey, data, minute = 10) => {
        localStorage.setItem(
            cacheKey,
            JSON.stringify({
                timestamp: Date.now(),
                expire: minute * 60 * 1000,
                data: data
            })
        );
    };

    getCache = (cacheKey) => {
        const cached = localStorage.getItem(cacheKey);

        if (!cached) return null;

        try {
            const parsed = JSON.parse(cached);

            if (parsed && Date.now() - parsed.timestamp < parsed.expire) {
                return parsed.data;
            }

            localStorage.removeItem(cacheKey);
            return null;
        } catch (err) {
            localStorage.removeItem(cacheKey);
            return null;
        }
    };

    getLotteryList = async () => {
        const cacheKey = `lotto_list_${Systems}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            const rows = Array.isArray(cachedData) ? cachedData : [];
            const firstLotto = rows.length > 0 ? rows[0] : null;

            this.setState({
                lottolist: rows,
                activeLotto: firstLotto,
                activeLottoIndex: 0
            });

            return;
        }

        this.setState({ loadingLotto: true });

        await instance.post("/api/v1/tabgamelist", {
            state: "lotto",
            System: Systems
        }).then((res) => {
            if (res.data.status === 200) {
                console.log("tabgamelistlotto", res.data.message);

                const rows = Array.isArray(res.data.message) ? res.data.message : [];
                const firstLotto = rows.length > 0 ? rows[0] : null;

                this.setCache(cacheKey, rows, 30);

                this.setState({
                    lottolist: rows,
                    activeLotto: firstLotto,
                    activeLottoIndex: 0
                });
            } else {
                this.setState({
                    lottolist: [],
                    activeLotto: null,
                    activeLottoIndex: 0
                });
            }
        }).catch((err) => {
            console.log("[LOTTO_LIST_ERROR]", err);

            this.setState({
                lottolist: [],
                activeLotto: null,
                activeLottoIndex: 0
            });
        }).finally(() => {
            this.setState({ loadingLotto: false });
        });
    };

    getLottoName = (item) => {
        return (
            item?.description ||
            item?.Description ||
            item?.proname ||
            item?.name ||
            item?.Name ||
            item?.title ||
            item?.Title ||
            item?.roomname ||
            item?.RoomName ||
            item?.room_name ||
            "-"
        );
    };

    getLottoCode = (item) => {
        return (
            item?.partner ||
            item?.Partner ||
            item?.providercode ||
            item?.provider_code ||
            item?.ProviderCode ||
            item?.code ||
            item?.Code ||
            item?.key ||
            item?.Key ||
            item?.roomid ||
            item?.RoomId ||
            item?.room_id ||
            item?.gameid ||
            item?.gamecode ||
            item?.GameCode ||
            ""
        );
    };

    getLottoImage = (item) => {
        return (
            item?.imagesec ||
            item?.selectimg ||
            item?.image ||
            item?.Image ||
            item?.img ||
            item?.img_path ||
            item?.imagepath ||
            item?.picture ||
            ""
        );
    };

    getLottoBanner = (item) => {
        return (
            item?.banner ||
            item?.Banner ||
            item?.bannerimg ||
            item?.banner_img ||
            item?.bannerpath ||
            item?.BannerPath ||
            item?.imagebanner ||
            item?.ImageBanner ||
            this.getLottoImage(item) ||
            ""
        );
    };

    selectLotto = (item, index) => {
        this.setState({
            activeLotto: item,
            activeLottoIndex: index
        });
    };

    playLotto = async (e, item = this.state.activeLotto) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        await this.checklogin();

        if (!this.state.loginstate) {
            await this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
            return;
        }

        const code = this.getLottoCode(item);

        if (!code) {
            await this.notify("error", "ไม่พบข้อมูลหวย กรุณาลองใหม่");
            return;
        }

        window.location.href = `/game/lotto/${code}`;
    };

    renderLottoIcon = (item) => {
        const img = this.getLottoImage(item);
        const name = this.getLottoName(item);
        const code = this.getLottoCode(item);

        if (img) {
            return (
                <img
                    src={img}
                    alt={name}
                    className="sub-icon"
                    loading="lazy"
                />
            );
        }

        return (
            <span
                className="sub-icon"
                style={{
                    width: 20,
                    height: 20,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 11,
                    fontWeight: 800
                }}
            >
                {String(code || name).substring(0, 2)}
            </span>
        );
    };

    renderLottoItem = (item, index) => {
        const name = this.getLottoName(item);
        const code = this.getLottoCode(item);
        const isActive = this.state.activeLottoIndex === index;

        return (
            <li
                key={`${code || name}-${index}`}
                className={`tab-header ${isActive ? "active" : ""}`}
                data-provider-name={name}
                data-provider-code={code}
                onClick={() => this.selectLotto(item, index)}
            >
                {index === 0 ? <p className="float-dot hot-provider">ฮอต</p> : null}

                <div className="tab-inner">
                    {this.renderLottoIcon(item)}
                    <span>{name}</span>
                </div>
            </li>
        );
    };

    renderActiveLottoDetail = () => {
        const { activeLotto } = this.state;

        if (!activeLotto) {
            return (
                <div className="bottom-category">
                    <div className="bottom-content">
                        <div className="title">ล็อตเตอรี่</div>
                        <div className="subtitle">ไม่พบข้อมูลหวย</div>
                        <div className="description">
                            กรุณาลองโหลดหน้าใหม่อีกครั้ง
                        </div>
                    </div>
                </div>
            );
        }

        const name = this.getLottoName(activeLotto);
        const code = this.getLottoCode(activeLotto);
        const img = this.getLottoBanner(activeLotto);

        return (
            <div className="bottom-category">
                <div className="bottom-content">
                    <div className="title">{name}</div>

                    <div className="subtitle">
                        หวยออนไลน์ เล่นง่าย ออกรางวัลไว ฝากถอนอัตโนมัติ
                    </div>

                    <div className="description">
                        เลือกเล่น {name} ระบบเสถียร ใช้งานง่าย รองรับทุกอุปกรณ์
                        พร้อมตรวจสอบผลและทำรายการได้ตลอด 24 ชั่วโมง
                    </div>

                    <button
                        type="button"
                        onClick={(e) => this.playLotto(e, activeLotto)}
                    >
                        เล่นตอนนี้
                    </button>
                </div>

                <div className="bottom-content-img">
                    {img ? (
                        <picture>
                            <source type="image/webp" srcSet={img} />
                            <img src={img} alt={name} loading="lazy" />
                        </picture>
                    ) : (
                        <div
                            style={{
                                width: "100%",
                                minHeight: 260,
                                borderRadius: 18,
                                background: "linear-gradient(135deg, #111827, #1f2937)",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 30,
                                fontWeight: 900
                            }}
                        >
                            {code || name}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    render() {
        const { lottolist, loadingLotto } = this.state;

        return (
            <>
                <div className="providerLandingIndexContainer lottery-container">
                    <div className="_productBannerContainer_1ma75_1 product-banner-container">
                        <div className="slick-slider slider slick-initialized">
                            <div className="slick-list">
                                <div
                                    className="slick-track"
                                    style={{
                                        width: "100%",
                                        opacity: 1,
                                        transform: "translate3d(0px, 0px, 0px)"
                                    }}
                                >
                                    <div
                                        data-index={0}
                                        className="slick-slide slick-active slick-current"
                                        tabIndex={-1}
                                        aria-hidden="false"
                                        style={{ outline: "none", width: "100%" }}
                                    >
                                        <div>
                                            <div
                                                className="_productBannerWrapper_1ma75_1 top top-provider-img"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="https://s3.newworld.center/image/9e4f8307-9e1d-45a9-8b46-cc257d34332c.webp"
                                                    className="_productBanner_1ma75_1 provider-banner"
                                                    alt="banner-img"
                                                />

                                                <div className="_content_1ma75_25 top-provider-content ">
                                                    <p className="_title_1ma75_48 provider-type">ล็อตเตอรี่</p>

                                                    <div className="_desc_1ma75_58 provider-desc">
                                                        <h4>หวยออนไลน์ครบวงจร</h4>
                                                        <h4>เล่นง่าย ออกรางวัลไว</h4>
                                                        <h5>
                                                            ลงทะเบียนวันนี้เพื่อรับรางวัล
                                                            <br />
                                                            <br />
                                                            &nbsp;
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className="bk8-logo-container">
                                                    <div className="logo-img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mid" id="provider-box">
                        <ul className="provider-box">
                            {loadingLotto ? (
                                <li className="tab-header active">
                                    <div className="tab-inner">
                                        <span>กำลังโหลดหวย</span>
                                    </div>
                                </li>
                            ) : lottolist.length > 0 ? (
                                lottolist.map((item, index) => this.renderLottoItem(item, index))
                            ) : (
                                <li className="tab-header active">
                                    <div className="tab-inner">
                                        <span>ไม่พบรายการหวย</span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>

                    {this.renderActiveLottoDetail()}
                </div>
            </>
        );
    }
}

export default App;